import { useMPEFetch } from '@retail/app/hooks';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { ConditionBinding, MarkupBinding } from '@retail/calculus/types';
import { mpeApi } from '@retail/mgpris/config';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';

interface Props extends QueryOptions {
  assortmentId: number;
  bindingLevel: ConditionBinding;
}

export const useGetActiveMarkupCondition = ({
  assortmentId,
  bindingLevel,
  ...queryOptions
}: Props) => {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<MarkupBinding | undefined>({
    queryKey: ['activeMarkup', assortmentId, bindingLevel],
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.activeMarkupCondition.getFullLinkPath(),
      searchParams: { assortmentId },
    }),
    method: 'POST',
    body: bindingLevel,
    token,
    ...queryOptions,
  });
};
